import React from "react";
import PropTypes from "prop-types";

Form.propTypes = {
  children: PropTypes.node,
  other: PropTypes.any,
};

export default function Form(props) {
  const { children, ...other } = props;

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      {...other}
      style={{ width: "100%" }}
    >
      {children}
    </form>
  );
}
